var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.deactivateProgramContest()}}},[_c('input',{staticClass:"btn btn-primary btn-lg btn-sm-block m-2",attrs:{"type":"submit","name":_vm.params.isActive === 1 ? 'deactivate' : 'activate'},domProps:{"value":_vm.params.isActive === 1
          ? 'De-Activate This Program/Contest'
          : 'Re-Activate This Program/Contest'}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }